import { useRef, useState } from "react";
import { IoIosArrowDown } from "react-icons/io";

function Accordion({ title, desc }: { title: string; desc: string }) {
  const [open, setOpen] = useState<boolean>(false);
  const accordionBodyRef = useRef<HTMLDivElement>(null);

  const toggler = () => {
    if (accordionBodyRef!.current!.clientHeight === 0) {
      accordionBodyRef!.current!.style!.height =
        accordionBodyRef?.current?.scrollHeight + "px";
      setOpen(true);
    } else {
      accordionBodyRef!.current!.style!.height = 0 + "px";
      setOpen(false);
    }
  };

  return (
    <div className=" border-b-2 border-[#8D9494]">
      <button
        className="flex justify-between items-center w-full py-4 lg:py-4  pr-4 lg:pr-6 space-x-6 text-left"
        onClick={toggler}
      >
        <h1 className="text-[28px] font-serif text-blue">{title}</h1>

        <div className="flex justify-center items-center text-blue min-w-[40px] min-h-[40px] lg:w-[55px] lg:h-[55px] rounded-[12px]">
          <span
            className={`transition-all text-[20px] lg:text-[30px] duration-[.3s] ease-[ease] ${
              open ? "rotate-[180deg]" : "rotate-0"
            }`}
          >
            <IoIosArrowDown color="" />{" "}
          </span>
        </div>
      </button>

      <div
        className="h-0 overflow-hidden transition-all duration-[.3s] ease-[ease]"
        ref={accordionBodyRef}
      >
        <div className="lg:pb-8 pb-6 px-8 lg:px-10">
          <p className="text-blue text-[20px] leading-[31.2px]">{desc}</p>
        </div>
      </div>
    </div>
  );
}

export default Accordion;
